import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import { useQuery, UseQueryResult } from 'react-query';
import { Dictionary } from '../lib';
import { getSortedDataWithUrl } from './hook-helpers';

interface UseDictionaryReferenceProps {
    type: string;
}

const isQueryEnabled = (type: string): boolean => {
    return type.includes('reference');
};

export const useDictionaryReference = ({
    type,
}: UseDictionaryReferenceProps): UseQueryResult<
    AxiosResponse<Dictionary[], any>,
    unknown
> => {
    const { getToken } = useAuth();
    const url = `/metadata/dictionary/referenceable/${type.toUpperCase()}`;
    return useQuery(
        `use-dictionary-reference-by-type-${type}`,
        async () => getSortedDataWithUrl(url, getToken()),
        {
            enabled: isQueryEnabled(type),
        }
    );
};
